// App.js — marketing site shell
import React from "react";
import "./jds-styles/main.scss";
import "./tailwind.css";
import { TokenProvider } from "@jds/core";
import Nav from "./routes/Nav";
import FooterComponent from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import { useLocation } from "react-router-dom";
import "./styles/App.css";

const MARKETING_PATHS = new Set(["/", "/contact", "/signup"]);

const App = () => {
  const location = useLocation();
  const showFooter =
    MARKETING_PATHS.has(location.pathname) &&
    location.pathname !== "/" &&
    !location.pathname.startsWith("/pdf/");

  return (
    <TokenProvider value={{ theme: "JioBase", mode: "light" }}>
      <ScrollToTop />
      <Nav />
      {showFooter && <FooterComponent />}
    </TokenProvider>
  );
};

export default App;
